import React, { useEffect, useState } from 'react';
import { Button, ProgressBar, Container, Row, Col, Card, Spinner, Modal } from 'react-bootstrap';
import { signInWithGoogle, auth, provider, signInWithPopup, onAuthStateChanged } from "./firebase";
import {  deleteDoc, getFirestore, doc, limit, setDoc, getDoc, collection,query, where, getDocs, addDoc, serverTimestamp, onSnapshot, orderBy, updateDoc, increment} from "firebase/firestore";
import {
  Chart as ChartJS,
  CategoryScale, LinearScale, PointElement,
  LineElement, Title, Tooltip, Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const fetchTimeSeries = async () => {
  const col = collection(db, 'opele');
  const q = query(col, orderBy('time'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

const db = getFirestore();

function App() {
  const [revenue, setRevenue] = useState(null);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [totalRevenue, setTotalRevenue] = useState(0);
  const [totalCredits, setTotalCredits] = useState(0);
  const [totalWithdrawal, setTotalWithdrawal] = useState(0);
  const [repeatedRevenue, setRepeatedRevenue] = useState(0);
  const [repeatedPayerCount, setRepeatedPayerCount] = useState(0);
  
  const [totalPayingUsers, setPayingUsers] = useState(0);
  const [registeredUsers, setRegisteredUsers] = useState(0);
  const [totalPriestsNumber, setTotalPriestsNumber] = useState(0);
  const [totalPriestsReq, setPriestsReq] = useState(0);

  const [totalGiftCards, setGiftCards] = useState(0);
  const [giftCardSum, setGiftCardSum] = useState(0);
  const [unclaimedGiftCards, setUnclaimedGiftCards] = useState(0);


  const [showModal, setShowModal] = useState(null); // 'users', 'revenue', 'priests'
  const [timeSeries, setTimeSeries] = useState([]);

  // total users
  useEffect(() => {
    const fetchUserCount = async () => {
      const usersCol = collection(db, 'priest_users');

      // Count all users
      const usersSnap = await getDocs(usersCol);
      setRegisteredUsers(usersSnap.size); 
      
      // Count only consultants (role === 'consultant')
      const consultantQuery = query(usersCol, where('role', '==', 'consultant'));
      const consultantSnap = await getDocs(consultantQuery);
      setTotalPriestsNumber(consultantSnap.size);

      // count all priests requests
      const priestsReqCol = collection(db, 'priest_requests');
      const priestsReqSnap = await getDocs(priestsReqCol);
      setPriestsReq(priestsReqSnap.size); 

      // count all paying users
      const payingUsersCol = collection(db, 'priest_recharged');
      const payingUsersSnap = await getDocs(payingUsersCol);
      setPayingUsers(payingUsersSnap.size); 

      setLoading(false)
    };

    fetchUserCount();
  }, []);

    // total credits
    useEffect(() => {
      const fetchTotalCredits = async () => {
        try {
          const usersCol = collection(db, 'priest_users');
          // only fetch users with credits > 0
          const creditsQuery = query(usersCol, where('credits', '>', 0));
          const creditsSnap = await getDocs(creditsQuery);

          let total = 0;
          creditsSnap.forEach(doc => {
            const data = doc.data();
            if (data.credits) {
              total += data.credits;
            }
          });

          setTotalCredits(total); // <-- make sure you have setTotalCredits in your state
        } catch (error) {
          console.error("Error fetching credits:", error);
        }
      };

      fetchTotalCredits();
    }, []);


// total revenue
  useEffect(() => {
    const fetchTotalRevenue = async () => {
      const revenueRef = collection(db, 'priest_recharged');
      const revenueSnap = await getDocs(revenueRef);
      let sum = 0;
      let repeatedSum = 0;
      let repeatedCount = 0;

      revenueSnap.forEach(doc => {
        const data = doc.data();
        if (typeof data.totalAmountPaid === 'number') {
          sum += data.totalAmountPaid;
        }

          if (typeof data.count === 'number' && data.count > 1) {
          repeatedSum += data.totalAmountPaid;
          repeatedCount += 1;
        }

      });

      setTotalRevenue(sum);
      setRepeatedRevenue(repeatedSum);       // optional: total $ from repeat payers
      setRepeatedPayerCount(repeatedCount);  // ✅ number of repeat customers
      setLoading(false)
    };

    fetchTotalRevenue();
  }, []);


    //  total Withdrawal
    useEffect(() => {
      const fetchTotalWithdrawal = async () => {
        const withdrawalRef = collection(db, 'withdrawal_requests');
        const withdrawalSnap = await getDocs(withdrawalRef);
        let sum = 0;

        withdrawalSnap.forEach(doc => {
          const data = doc.data();
          if (typeof data.amount === 'number') {
            sum += data.amount;
          }
        });

        setTotalWithdrawal(sum);
        setLoading(false)
      };

      fetchTotalWithdrawal();
    }, []);


    //  total GiftCards
  useEffect(() => {
    const fetchGiftCards = async () => {
      const GiftCardsRef = collection(db, 'giftCards');
      const GiftCardsSnap = await getDocs(GiftCardsRef);

      let sum = 0;
      let unclaimedCount = 0;


      GiftCardsSnap.forEach(doc => {
        const data = doc.data();
        if (typeof data.amount === 'number') {
          sum += data.amount;
        }

          // Count unclaimed gift cards
          if (data.status === 'unclaimed') {
            unclaimedCount += 1;
          }
      });

      setGiftCardSum(sum);

      // count all giftCards
      const giftCardsSnap = await getDocs(GiftCardsRef);
      setGiftCards(giftCardsSnap.size); 

      // get the number of documents in giftCards that have status: "unclaimed"
      setUnclaimedGiftCards(unclaimedCount); // ✅ number of unclaimed cards


      setLoading(false)
    };

    fetchGiftCards();
  }, []);




   useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      setUser(authUser);
      // setLoadingauth(false); // Mark loading as complete
    });

    return () => unsubscribe();
    }, []);

  useEffect(() => {
    (async () => {
      const data = await fetchTimeSeries();
      setTimeSeries(data);
    })();
  }, []);


    // Save the dashboard metrics to Firestore once all metrics have loaded
    useEffect(() => {
      if (loading) return;

      if (
          registeredUsers === 0 &&
          totalPriestsNumber === 0 &&
          totalRevenue === 0 &&
          totalWithdrawal === 0 &&
          repeatedRevenue === 0 &&
          repeatedPayerCount === 0 &&
          totalPayingUsers === 0 &&
          totalPriestsReq === 0 &&
          totalGiftCards === 0 &&
          giftCardSum === 0 &&
          unclaimedGiftCards === 0
        ) {
          return; // Avoid saving empty default values
        }

      const saveDashboardMetricsToFirestore = async () => {
        const today = new Date();
        const docId = today.toISOString().split('T')[0]; // "2025-08-07"

        const metricsRef = doc(db, 'opele', docId);
        const existingSnap = await getDoc(metricsRef);
        const totalOnboardedPriests = totalPriestsNumber - 1

        const newMetrics = {
          registeredUsers,
          totalOnboardedPriests,
          totalRevenue,
          totalWithdrawal,
          repeatedRevenue,
          repeatedPayerCount,
          totalPayingUsers,
          totalPriestsReq,
          totalGiftCards,
          giftCardSum,
          unclaimedGiftCards,
          time: new Date(), // timestamp of save
        };

        if (existingSnap.exists()) {
          const existingData = existingSnap.data();

          // Build only the fields that have changed
          const fieldsToUpdate = {};
          Object.entries(newMetrics).forEach(([key, value]) => {
            const existingValue = existingData[key];
            if (existingValue !== value) {
              fieldsToUpdate[key] = value;
            }
          });

          if (Object.keys(fieldsToUpdate).length > 0) {
            await updateDoc(metricsRef, fieldsToUpdate);
            console.log("Updated metrics:", fieldsToUpdate);
          } else {
            console.log("No changes to metrics. Skipped update.");
          }

        } else {
          await setDoc(metricsRef, newMetrics);
          console.log("Saved new metrics for today.");
        }
      };

      saveDashboardMetricsToFirestore();

    }, [
      loading,
      registeredUsers,
      totalPriestsNumber,
      totalRevenue,
      totalWithdrawal,
      repeatedRevenue,
      repeatedPayerCount,
      totalPayingUsers,
      totalPriestsReq,
      totalGiftCards,
      giftCardSum,
      unclaimedGiftCards
    ]);

   

  
    const handleGoogleSignup = async () => {
    
      const googleUser = await signInWithGoogle();
      if (googleUser) {
        setUser(googleUser);
        // console.log("googleUser: ", googleUser)

      const db = getFirestore();

      const userRef = doc(db, "priest_users", googleUser.uid);
      let userSnap = await getDoc(userRef);


      if (!userSnap.exists()) {
        // If user does not exist in Firestore, create a new record
        
      }

      // Redirect if user is not oluwo or ose
      if (userSnap.exists() && userSnap.data().email !== "okojieose111@gmail.com" || "kunlefreedom@gmail.com") {
        
      }
      
      // refresh page automatically
      window.location.reload();



      }
      
    };


      const chartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: 'index',
            intersect: false,
          },
          plugins: {
            legend: {
              display: true,
              labels: {
                color: '#6b7280', // Tailwind gray-500
                font: { size: 13, family: 'Inter, sans-serif' },
                usePointStyle: true,
                pointStyle: 'circle',
                boxWidth: 5, // ⬅ shrink legend circle size
                boxHeight: 5, // ⬅ optional for even control
                padding: 15,  // ⬅ optional spacing between legend items
              },
            },
            tooltip: {
              backgroundColor: '#111827', // Tailwind gray-900
              titleColor: '#f9fafb', // gray-50
              bodyColor: '#f9fafb',
              cornerRadius: 8,
              padding: 12,
              titleFont: { size: 13, weight: 'bold' },
              bodyFont: { size: 12 },
            },
          },
          scales: {
            x: {
              grid: { display: false, drawBorder: false },
              ticks: { color: '#9ca3af', font: { size: 12 } },
            },
            y: {
              grid: { color: 'rgba(156, 163, 175, 0.15)', drawBorder: false },
              ticks: { color: '#9ca3af', font: { size: 12 } },
            },
          },
          elements: {
            line: {
              tension: 0.4, // smooth curves
              borderWidth: 2,
            },
            point: {
              radius: 3,
              hoverRadius: 6,
              backgroundColor: '#fff',
              borderWidth: 2,
            },
          },
        };


        const palette = [
          '#3b82f6', // blue-500
          '#10b981', // emerald-500
          '#f59e0b', // amber-500
          '#ef4444', // red-500
          '#8b5cf6', // violet-500
          '#6b7280', // gray-500
        ];



      const commonModal = (title, chartComponents) => (
      <Modal size="lg" show={showModal} onHide={() => setShowModal(null)}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{chartComponents}</Modal.Body>
      </Modal>
      );

    const labels = timeSeries.map(d => d.id);
    const datasetsFor = (keys) => {
    // Define your friendly labels here
    const labelMap = {
      registeredUsers: "Total Users",
      totalPayingUsers: "Total Buyers",
      repeatedPayerCount: "Repeated Buyers",
      totalRevenue: "Total Revenue ($)",
      totalWithdrawal: "Total Withdrawn ($)",
      repeatedRevenue: "Repeated Revenue ($)",
      giftCardSum: "Gift Card Revenue ($)",
      totalGiftCards: "Total Gift Cards",
      claimedGiftCards: "Claimed Gift Cards",
      totalPriestsReq: "Priest Requests",
      totalOnboardedPriests: "Onboarded Priests"
    };

    return keys.map((key, i) => {
      let data;

      if (key === 'claimedGiftCards') {
        data = timeSeries.map(d =>
          (d.totalGiftCards || 0) - (d.unclaimedGiftCards || 0)
        );
      } else {
        data = timeSeries.map(d => d[key] || 0);
      }

      return {
        label: labelMap[key] || key.replace(/([A-Z])/g, ' $1'),
        data,
        borderColor: palette[i % palette.length],
        backgroundColor: palette[i % palette.length] + '33',
        fill: false,
        pointBorderColor: palette[i % palette.length],
        pointBackgroundColor: '#fff',
      };
    });
  };




  return (
  <Container className="mt-3">
    {/* Top Navigation Bar */}
    <div className="d-flex justify-content-between align-items-center p-3 bg-white rounded shadow-sm mb-4">
      <a href="https://www.opele.priests.africa" className="text-decoration-none">
        <img src="./logo.png" width="120" alt="logo" />
      </a>

      <div>
        <a onClick={handleGoogleSignup} className="cursor-pointer">
          {!user ? (
            <img
              src="./account.png"
              alt="profile"
              className="rounded-circle"
              style={{ width: 40, height: 40 }}
            />
          ) : (
            <img
              src={user.photoURL}
              alt={user.displayName}
              className="rounded-circle"
              style={{ width: 40, height: 40 }}
              onClick={show ? handleClose : handleShow}
            />
          )}
        </a>
      </div>
    </div>

    {/* Dashboard Metrics */}
    <Row className="g-4">
      {/* Users Metrics */}
      <Col md={6}>
        <Card className="h-100 border-0 shadow rounded-4" style={{ backgroundColor: "#FFFFFF" }}>
          <Card.Header className="bg-primary text-white rounded-top-4 fw-semibold d-flex justify-content-between align-items-center">
            <span>👩🏽‍🦰 Users Metrics</span>
            <Button className="text-white p-1" onClick={() => setShowModal('users')}>
              More?
            </Button>
          </Card.Header>
          
          <Card.Body>
            {loading ? (
              <Spinner animation="border" variant="primary" />
            ) : (
              <div className="text-dark fs-6">
                <p className="mb-2">Total Users: <strong>{registeredUsers}</strong></p>
                <p className="mb-0">Total Buyers: <strong>{totalPayingUsers}</strong></p>
                <p className="mb-0">Buyers % of Total Users: <strong>{((totalPayingUsers/registeredUsers) * 100).toFixed(2)}%</strong></p>
                <ProgressBar
                  now={(totalPayingUsers / registeredUsers) * 100}
                  // label={`${((totalPayingUsers / registeredUsers) * 100).toFixed(1)}%`}
                  style={{ height: '10px', marginBottom: '10px' }}
                />
                <p className="mb-0">Repeated Buyers % of Total Users: <strong>{((repeatedPayerCount/registeredUsers) * 100).toFixed(2)}%</strong></p>
                <ProgressBar
                  now={(repeatedPayerCount/registeredUsers) * 100}
                  // label={`${((totalPayingUsers / registeredUsers) * 100).toFixed(1)}%`}
                  style={{ height: '10px', marginBottom: '10px' }}
                />
              </div>
            )}
              
          </Card.Body>
        </Card>
      </Col>

      {/* Revenue Metrics */}
      <Col md={6}>
        <Card className="h-100 border-0 shadow rounded-4" style={{ backgroundColor: "#FFFFFF" }}>
          <Card.Header className="bg-success text-white rounded-top-4 fw-semibold d-flex justify-content-between align-items-center">
            <span>💰 Revenue Metrics</span>
            <Button variant='success' className="text-white p-1" onClick={() => setShowModal('revenue')}>
              More?
            </Button>
          </Card.Header>
          <Card.Body>
            {loading ? (
              <Spinner animation="border" variant="success" />
            ) : (
              <div className="text-dark fs-6">
                <p className="mb-0">Total Revenue: <strong>${totalRevenue.toFixed(2)}</strong></p>
                <p className="mb-0">Total Credit Balance: <strong>${totalCredits.toFixed(2)}</strong></p>
                <p className="mb-2">Total Withdrawn: <strong>${totalWithdrawal.toFixed(2)}</strong></p>
                <p className="mb-0">Repeated Buyers % of Revenue: <strong>{((repeatedRevenue / totalRevenue) * 100).toFixed(2)}%</strong></p>
                <ProgressBar
                  now={(repeatedRevenue / totalRevenue) * 100}
                  // label={`${((repeatedRevenue / totalRevenue) * 100).toFixed(1)}%`}
                  variant="success"
                  style={{ height: '10px', marginBottom: '20px' }}
                />
                <p className="mb-0">Gift Card Revenue: <strong>${giftCardSum.toFixed(2)}</strong></p>
                <p className="mb-0">Gift Card Sold: <strong>{totalGiftCards}</strong></p>
                <p className="mb-0">Gift Card % of Revenue: <strong>{((totalGiftCards / totalRevenue) * 100).toFixed(2)}%</strong></p>
                <ProgressBar
                  now={(totalGiftCards / totalRevenue) * 100}
                  // label={`${((repeatedRevenue / totalRevenue) * 100).toFixed(1)}%`}
                  variant="success"
                  style={{ height: '10px', marginBottom: '20px' }}
                />

                <p className="mb-0">Num. of Claimed Gift Cards: <strong>{totalGiftCards - unclaimedGiftCards}</strong></p>
                <p className="mb-0">Claimed Gift Cards % of Total Gift Cards : <strong>{100 - ((unclaimedGiftCards / totalGiftCards) * 100).toFixed(2)}%</strong></p>
                <ProgressBar
                  now={100 - (unclaimedGiftCards / totalGiftCards) * 100}
                  // label={`${((repeatedRevenue / totalRevenue) * 100).toFixed(1)}%`}
                  variant="success"
                  style={{ height: '10px', marginBottom: '10px' }}
                />

              </div>
            )}
          </Card.Body>
        </Card>
      </Col>

      {/* Priests Metrics */}
      <Col md={6}>
        <Card className="h-100 border-0 shadow rounded-4" style={{ backgroundColor: "#FFFFFF" }}>
           <Card.Header className="bg-dark text-white rounded-top-4 fw-semibold d-flex justify-content-between align-items-center">
            <span>🧙🏽‍♂️ Priests Metrics</span>
            <Button variant='dark' className="text-white p-1" onClick={() => setShowModal('priests')}>
              More?
            </Button>
          </Card.Header>
          <Card.Body>
            {loading ? (
              <Spinner animation="border" variant="dark" />
            ) : (
              <div className="text-dark fs-6">
                <p className="mb-0">Total Priest Requests: <strong>{totalPriestsReq}</strong></p>
                <p className="mb-0">Onboarded Priests: <strong>{totalPriestsNumber - 1}</strong></p>
              </div>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>

      {/* Conditional Modals */}

      {showModal === 'users' && commonModal(
          "Users Metrics",
          <div style={{ height: 350 }}>
            <Line
              data={{ labels, datasets: datasetsFor(['registeredUsers', 'totalPayingUsers', 'repeatedPayerCount']) }}
              options={chartOptions}
            />
          </div>
        )}

      {showModal === 'revenue' && commonModal(
          "Revenue Metrics",
          <>
            <div style={{ height: 350, marginBottom: 20 }}>
              <Line
                data={{
                  labels,
                  datasets: datasetsFor(
                    ['totalRevenue', 'totalWithdrawal', 'repeatedRevenue', 'giftCardSum'],
                    ['blue','red','orange','purple']
                  ),
                }}
                options={chartOptions}
              />
            </div>
            <div style={{ height: 350 }}>
              <Line
                data={{
                  labels,
                  datasets: datasetsFor(
                    ['totalGiftCards', 'claimedGiftCards'],
                    ['green','grey']
                  ),
                }}
                options={chartOptions}
              />
            </div>
          </>
        )}

        {showModal === 'priests' && commonModal(
          "Priests Metrics",
          <div style={{ height: 350 }}>
            <Line
              data={{
                labels,
                datasets: datasetsFor(
                  ['totalPriestsReq', 'totalOnboardedPriests'],
                  ['blue','green']
                ),
              }}
              options={chartOptions}
            />
          </div>
        )}

  </Container>
);


}

export default App;
